import React from 'react'
import { useTranslation } from 'react-i18next'
import { RequestState } from '../../@types/enumsGlobal'
import { RadioGroup } from '../../components/radioGroup/radioGroup'
import styles from "./RequestStatePanel.module.scss"
interface Props {
    multipleSelect?: boolean
    onMultipleSelectChange?: (value: boolean) => void
    requestState: RequestState | undefined
    onRequestStateChange?: (value: RequestState | undefined) => void
}

export const RequestStatePanel: React.FC<Props> = (props) => {
    const { t } = useTranslation()
    return (
        <div className={styles.requestStatePanel}>
            <RadioGroup
                value={{ displayName: "", value: props.requestState }}
                onSelect={(option) => {
                    props.onRequestStateChange?.(option?.value)
                }}
                options={[
                    { displayName: t("general.all"), value: undefined },
                    { displayName: t("general.allIngoing"), value: "Incoming" as RequestState},
                    { displayName: t("general.allOutgoing"), value: "Outgoing" as RequestState},
                ]}
            />
        </div>
    )
}
